import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Back, the way the browser's Back button goes: to the page the user came from. When this page was opened directly (a pasted link, a reload
 * in a new tab) there is nothing to go back to, so it goes to `fallback` instead.
 */
export function useGoBack(fallback: string): () => void {
    const navigate = useNavigate()
    const location = useLocation()
    // `key` is "default" on the first entry of the session's history.
    return () => (location.key !== 'default' ? navigate(-1) : navigate(fallback, { replace: true }))
}
